import ParkingAreaFixedTimePage from "./parkingAreaFixedTime";

export default ParkingAreaFixedTimePage;